import {AdminMarketplaceType, AdminProductStatus} from '../../gen/api/models';

export function productStatusBadge(status: AdminProductStatus): string {
    switch (status) {
        case AdminProductStatus.ProductStatusReadyForSale:
            return 'lime';
        case AdminProductStatus.ProductStatusActive:
            return 'green';
        case AdminProductStatus.ProductStatusDraft:
            return 'grey';
        case AdminProductStatus.ProductStatusReserved:
            return 'yellow';
        case AdminProductStatus.ProductStatusSold:
            return 'blue';
        case AdminProductStatus.ProductStatusTookForThemself:
            return 'purple';
        case AdminProductStatus.ProductStatusNeedReview:
            return 'orange';
    }
}

export function productStatusLabel(status: AdminProductStatus): string {
    switch (status) {
        case AdminProductStatus.ProductStatusReadyForSale:
            return 'Ready for Sale';
        case AdminProductStatus.ProductStatusActive:
            return 'Active';
        case AdminProductStatus.ProductStatusDraft:
            return 'Draft';
        case AdminProductStatus.ProductStatusReserved:
            return 'Reserved';
        case AdminProductStatus.ProductStatusSold:
            return 'Sold';
        case AdminProductStatus.ProductStatusTookForThemself:
            return 'Took For Themself';
        case AdminProductStatus.ProductStatusNeedReview:
            return 'Need Review';
    }
}

export function groupSaleStatusBadge(status: string): string {
    switch (status) {
        case 'active':
            return 'green';
        case 'inactive':
            return 'grey';
        default:
            return 'default';
    }
}

export function groupSaleStatusLabel(status: string): string {
    switch (status) {
        case 'active':
            return 'Active';
        case 'inactive':
            return 'Inactive';
        default:
            return 'Unknown';
    }
}

export function marketplaceLabel(marketplace: AdminMarketplaceType): string {
    switch (marketplace) {
        case AdminMarketplaceType.MarketplaceTypeFacebook:
            return 'Facebook';
        case AdminMarketplaceType.MarketplaceTypeEbay:
            return 'Ebay';
        case AdminMarketplaceType.MarketplaceTypeOfferUp:
            return 'Offer Up';
        case AdminMarketplaceType.MarketplaceTypeCraigsList:
            return 'Craigs List';
        case AdminMarketplaceType.MarketplaceTypeMarcari:
            return 'Marcari';
        case AdminMarketplaceType.MarketplaceTypePoshmark:
            return 'Poshmark';
        case AdminMarketplaceType.MarketplaceTypeWalmart:
            return 'Walmart';
        case AdminMarketplaceType.MarketplaceTypeDepop:
            return 'Depop';
        default:
            return 'Unknown Marketplace';
    }
}
